export const getScannersSelector = store => {
    return store.getIn(["scanners", "scanners"])
}
export const getScannersCountSelector = store => {
    return store.getIn(["scanners", "scannersCount"])
}
